module.exports = __webpack_public_path__ + "static/media/Mike Stud - Fly You To The Moon.1a53a7d4.mp3";